import React, { useState } from 'react';
import { createAmazonEvent, deleteAmazonEvent } from '../../services/salesEstimateService';

function AmazonEventsManager({ events, onEventsChanged, onClose }) {
    const [eventName, setEventName] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleCreate = async (e) => {
        e.preventDefault();
        if (!eventName || !startDate || !endDate) {
            setError("Please fill all fields");
            return;
        }
        setLoading(true);
        setError(null);
        try {
            await createAmazonEvent({ event_name: eventName, start_date: startDate, end_date: endDate });
            setEventName('');
            setStartDate('');
            setEndDate('');
            if (onEventsChanged) onEventsChanged();
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Delete this event?")) return;
        setLoading(true);
        try {
            await deleteAmazonEvent(id);
            if (onEventsChanged) onEventsChanged();
        } catch (err) {
            alert(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '12px' }}>
                    <div className="modal-header bg-light border-bottom-0" style={{ borderRadius: '12px 12px 0 0' }}>
                        <h5 className="modal-title fw-bold text-dark">
                            <i className="bi bi-calendar-event me-2"></i> Amazon Seasonal Events
                        </h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body p-4">
                        <p className="text-muted small mb-4">
                            Define date ranges for major events (e.g., Prime Day, Black Friday) so they are highlighted in the Price Elasticity chart.
                        </p>
                        
                        {error && <div className="alert alert-danger p-2 small">{error}</div>}

                        {/* List */}
                        <div className="table-responsive mb-4">
                            <table className="table table-sm table-hover align-middle">
                                <thead className="table-light">
                                    <tr>
                                        <th>Event Name</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                        <th className="text-end">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {events.length === 0 ? (
                                        <tr><td colSpan="4" className="text-center text-muted py-3">No events configured</td></tr>
                                    ) : (
                                        events.map(ev => (
                                            <tr key={ev.id}>
                                                <td className="fw-bold">{ev.event_name}</td>
                                                <td>{ev.start_date}</td>
                                                <td>{ev.end_date}</td>
                                                <td className="text-end">
                                                    <button 
                                                        className="btn btn-sm btn-outline-danger"
                                                        onClick={() => handleDelete(ev.id)}
                                                        disabled={loading}
                                                    >
                                                        <i className="bi bi-trash"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Create Form */}
                        <div className="bg-light p-3 rounded border">
                            <h6 className="fw-bold mb-3">Add New Event</h6>
                            <form onSubmit={handleCreate} className="row g-2 align-items-end">
                                <div className="col-md-4">
                                    <label className="form-label small text-muted mb-1">Event Name</label>
                                    <input type="text" className="form-control form-control-sm" value={eventName} onChange={e => setEventName(e.target.value)} placeholder="e.g. Prime Fall Deal" required />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label small text-muted mb-1">Start Date</label>
                                    <input type="date" className="form-control form-control-sm" value={startDate} onChange={e => setStartDate(e.target.value)} required />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label small text-muted mb-1">End Date</label>
                                    <input type="date" className="form-control form-control-sm" value={endDate} onChange={e => setEndDate(e.target.value)} required />
                                </div>
                                <div className="col-md-2">
                                    <button type="submit" className="btn btn-sm btn-primary w-100" disabled={loading}>
                                        {loading ? '...' : 'Add Event'}
                                    </button>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default AmazonEventsManager;
